/**
 * Platzhalter während der Migration: Seite wird auf Solid migriert.
 */
import { useLocation } from '@solidjs/router';
import { useTranslation } from '../context/LanguageContext';

export default function PlaceholderPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const path = () => location.pathname;

  return (
    <div style={{ padding: '2rem', 'text-align': 'center', color: '#888' }}>
      <h1>{t('placeholder.title')}</h1>
      <p>Route: <strong>{path()}</strong></p>
      <p>{t('placeholder.text')}</p>
    </div>
  );
}
